import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'
import LeftBar from '../../leftbar/LeftBar'

export default function KariyerMerkezleri()
{
    const title = "OKAF Kariyer Merkezleri İletişim Bİlgileri - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın kariyer merkezlerinin iletişim bilgilerine ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Kariyer Merkezleri İletisim"></PageTitle>
            <div class="container">
                <div class="my-4">
                    <div class="custom-content">
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive tableBlock">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Üniversite</th>
                                                <th>Müdür/Koordinatör</th>
                                                <th>Eposta</th>
                                                <th>Telefon</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><a href='https://kariyer.samsun.edu.tr' target='_blank'>SAMSUN ÜNİVERSİTESİ</a></td>
                                                <td>Dr. Öğr. Üyesi Engin BAYTÜRK</td>
                                                <td>kariyermerkezi@samsun.edu.tr</td>
                                                <td>0 362 313 0055/2003</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://kariyer.amasya.edu.tr' target='_blank'>AMASYA ÜNİVERSİTESİ</a></td>
                                                <td>Doç. Dr. Resul ÇEKİN</td>
                                                <td>kariyer@amasya.edu.tr</td>
                                                <td>0 358 211 5005/3661</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://karmer.karatekin.edu.tr' target='_blank'>ÇANKIRI KARATEKİN ÜNİVERSİTESİ</a></td>
                                                <td>Doç. Dr. Barış ÖZTUNA</td>
                                                <td>kariyermerkezi@karatekin.edu.tr</td>
                                                <td>0 376 218 95 00/7870</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://kariyer.hitit.edu.tr' target='_blank'>HİTİT ÜNİVERSİTESİ</a></td>
                                                <td>Dr. Öğr. Üyesi Ömür DEMİRER</td>
                                                <td>kariyer@hitit.edu.tr</td>
                                                <td>0 364 219 1948</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://kariyer.kastamonu.edu.tr' target='_blank'>KASTAMONU ÜNİVERSİTESİ</a></td>
                                                <td>Doç. Dr. Şerif DEMİR</td>
                                                <td>kariyer@kastamonu.edu.tr</td>
                                                <td>0 366 280 1349</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://kariyer.omu.edu.tr/tr' target='_blank'>ONDOKUZ MAYIS ÜNİVERSİTESİ</a></td>
                                                <td>Prof. Dr. Kemal YILDIZLI</td>
                                                <td>kariyer@omu.edu.tr</td>
                                                <td>0 362 312 1919/1691</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://kariyermerkezi.odu.edu.tr' target='_blank'>ORDU ÜNİVERSİTESİ</a></td>
                                                <td>Dr. Öğr. Üyesi Şenel ÇITAK</td>
                                                <td>kariyermerkezi@odu.edu.tr</td>
                                                <td>0 452 233 4865/4158</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://mezun.sinop.edu.tr' target='_blank'>SİNOP ÜNİVERSİTESİ</a></td>
                                                <td>Dr.Öğr. Üyesi Cem DÖNMEZOĞULLARI</td>
                                                <td>sematan@sinop.edu.tr</td>
                                                <td>0 368 271 5757/2097</td>
                                            </tr>
                                            <tr>
                                                <td><a href='https://karmer.gop.edu.tr' target='_blank'>TOKAT GAZİOSMANPAŞA ÜNİVERSİTESİ</a></td>
                                                <td>Doç. Dr. Kerem KILIÇER</td>
                                                <td>karmer@gop.edu.tr</td>
                                                <td>0 356 252 1616/1485</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
